/**
 * 회원가입 폼: Form.ts로 AJAX 제출.
 * 성공 시 메시지 후 redirect, 실패 시 #auth-signup-error에 표시.
 * Form must have id="auth-signup-form" and data-submit-url.
 */
import { Form } from "../../core/Form";

const FORM_ID = "auth-signup-form";
const ERROR_BOX_ID = "auth-signup-error";

function getErrorBox(): HTMLElement | null {
  return document.getElementById(ERROR_BOX_ID);
}

function renderError(message: string | null): void {
  const box = getErrorBox();
  if (!box) return;
  if (message === null || message === "") {
    box.innerHTML = "";
    box.setAttribute("hidden", "");
    return;
  }
  const wrap = document.createElement("div");
  wrap.className = "auth-page__error";
  wrap.textContent = message;
  box.innerHTML = "";
  box.appendChild(wrap);
  box.removeAttribute("hidden");
}

function getFirstError(errors: Record<string, string[]> | undefined): string {
  if (!errors || typeof errors !== "object") return "";
  const first = Object.values(errors).flat()[0];
  return typeof first === "string" ? first : "";
}

function isKo(): boolean {
  return document.documentElement.lang?.startsWith("ko") ?? false;
}

export function initAuthSignupForm(): void {
  const form = document.getElementById(FORM_ID) as HTMLFormElement | null;
  if (!form) return;

  const submitUrl = form.dataset.submitUrl ?? form.action;
  if (!submitUrl) return;

  new Form(form, {
    submitUrl,
    submitButtonSelector: "button[type=submit]",
    loaderSelector: "",
    requestFailedMessage: isKo() ? "요청을 보낼 수 없습니다." : "Request failed.",
    invalidResponseMessage: isKo() ? "응답을 처리할 수 없습니다." : "Invalid response.",
    onSuccess: (data) => {
      const msg = (data?.message ?? data?.msg ?? "") as string;
      const redirect = (data?.data as { redirect?: string } | undefined)?.redirect;
      if (msg) alert(msg);
      if (redirect) window.location.href = redirect;
    },
    onFail: (message, data) => {
      const errors = data?.errors as Record<string, string[]> | undefined;
      const first = getFirstError(errors);
      renderError(first || message || (isKo() ? "회원가입에 실패했습니다." : "Sign up failed."));
    },
  }).init();

  form.addEventListener("submit", () => renderError(null));
}
